import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  exp: number;
  iat?: number;
  [key: string]: unknown;
}

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true; // Treat as expired if there's an error decoding
  }
};

/**
 * Get token expiration details for debugging
 */
export const getTokenExpirationInfo = (token: string): { 
  isExpired: boolean; 
  expiresAt: Date | null; 
  expiresIn: string | null;
  issuedAt: Date | null;
} => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    const isExpired = decoded.exp < currentTime;
    const expiresAt = new Date(decoded.exp * 1000);
    const issuedAt = decoded.iat ? new Date(decoded.iat * 1000) : null;
    
    const secondsRemaining = decoded.exp - currentTime;
    let expiresIn: string | null = null;
    
    if (secondsRemaining > 0) {
      const hours = Math.floor(secondsRemaining / 3600);
      const minutes = Math.floor((secondsRemaining % 3600) / 60);
      expiresIn = `${hours}h ${minutes}m`;
    } else {
      const secondsAgo = Math.abs(secondsRemaining);
      const hours = Math.floor(secondsAgo / 3600);
      const minutes = Math.floor((secondsAgo % 3600) / 60);
      expiresIn = `expired ${hours}h ${minutes}m ago`;
    }
    
    return { isExpired, expiresAt, expiresIn, issuedAt };
  } catch (error) {
    console.error('Error decoding token:', error);
    return { isExpired: true, expiresAt: null, expiresIn: null, issuedAt: null };
  }
};

export const timeout = (ms: number): Promise<void> => 
  new Promise((resolve) => setTimeout(resolve, ms));

